


















import {Component, Prop, Vue} from "vue-property-decorator";
import {Getter} from 'vuex-class';
import TicketArray from '@/components/Ticket/TicketArray';
import TicketCmpt from '@/components/Ticket/TicketCmpt.vue';
import Ticket from '../Ticket/Ticket';

@Component({
    components: {
        TicketCmpt,
    }
})
export default class Tickets extends Vue {
    @Getter('tickets') private tickets!: TicketArray;

    get firstColumn(): Ticket[] {
        return this.tickets.all.slice(0, 10);
    }

    get secondColumn(): Ticket[] {
        return this.tickets.all.slice(10, 20);
    }

    get thirdColumn(): Ticket[] {
        return this.tickets.all.slice(20, 30);
    }
    
    get fourthColumn(): Ticket[] {
        return this.tickets.all.slice(30, 40);
    }

    select(ticket: Ticket) {
        this.$emit('selected', ticket);
    }
}
